{
  "Mon": "Montag",
  "Tue": "Dienstag",
  "Wed": "Mittwoch",
  "Thu": "Donnerstag",
  "Fri": "Freitag",
  "Sat": "Samstag",
  "Sun": "Sonntag",
  "CORE": {
    "notificationDateFormat": "dd.MM.yyyy",
    "update": "Lade...",
    "youAreOffline": "Du bist offline! Verbinde dich mit einem Netzwerk und versuche es später noch einmal!",
    "comeBack": "{{icon}} Deine Ski warten",
    "help": "Hilfe",
    "notification": {
      "ok": "Verstanden"
    },
    "skiHire": "Skiverleih"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Bezahlen Sie in Ihrer Heimatwährung (EUR oder CHF). Alpy.com übernimmt für Sie die Wechselkursgebühren.",
        "searchHeadline": "Wo möchten Sie Ihre Skier oder Ihr Snowboard ausleihen?"
      },
      "showTownReserveEarlyEnoughInfo": "Bitte beachten Sie, dass Skiverleiher während der Saison Materialengpässe haben können. Wir empfehlen daher immer im Vorhinein zu reservieren.",
      "shop_filter_distance_to_center": "<strong>Entfernung</strong> vom Stadtzentrum: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "SUCHEN",
        "promocode": {
          "couponCodeIsInCart": "Der Gutscheincode „ {{ code }} “ wurde Ihrem Warenkorb hinzugefügt und wird auf der Checkout-Seite berücksichtigt.",
          "typePromo": "PROMO",
          "typeCoupon": "GUTSCHEIN"
        }
      }
    },
    "offer": {
      "title": "Deswegen mit {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Sichern Sie sich die besten Verleih-Preise durch Ihre Onlinebuchung",
      "listedBrands": "Geführte Marken",
      "topTowns": "Top Skiverleih-Orte"
    },
    "sidebar": {
      "hotlineItalic": "Wir helfen Ihnen gerne!",
      "callNow": "Rufen Sie uns an: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Bitte geben sie von jedem Kind das Alter an. (Alter bei Mietantritt)",
        "onePersonRequired": "Mindestens eine Person auswählen",
        "enterTown": "Bitte geben Sie einen Ort an"
      },
      "minified": {
        "users": "{{ number_adults }} Erwachsene, {{ number_children }} Kinder",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE dd.MM.yy"
      },
      "datePickerDisplayFormat": "EEEEEE dd.MM.yy",
      "datePickerPreviousMessage": "Sie können Ihr Material bereits am <span>{{ date }}</span> ab 15:30 beim Shop abholen. Nachtskilauf ausgenommen.",
      "datePickerPreviousMessageDateFormat": "dd.MM.yy",
      "formSearchLabel": "Ort, Skigebiet, Bundesland, Land, Shopname, ...",
      "formSearchInfo": "Einen Moment bitte, ihr gewünschter Ort wird gesucht...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} Shop(s)",
      "formSearchResultShowAll": "Zeige alle {{ count }} Ergebnisse",
      "formSearchResultGroupLocations": "Skiort",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Regionen",
      "formSearchResultGroupCountries": "Länder",
      "formSearchButtonLabelDelivery": "Ab {{price}}",
      "deliverToHotel": "Ich möchte, dass die Ausrüstung kostenlos zu meiner Unterkunft geliefert wird!",
      "formStartDate": "Erster Miettag",
      "formEndDate": "Letzter Miettag",
      "formNumberOfPeople": "Anzahl der Personen",
      "formAdultsLabel": "Erwachsene",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Erwachsene",
        "adultSingle": "Erwachsener",
        "adultMultiple": "Erwachsene",
        "childNone": "Kinder",
        "childSingle": "Kind",
        "childMultiple": "Kinder"
      },
      "formAdultsLabelInfo": "über 18 Jahre bei Mietantritt",
      "formChildrenLabel": "Kinder",
      "formChildrenLabelInfo": "unter 18 Jahre bei Mietantritt",
      "formChildInputLabelInfo": "Wie alt ist Ihr Kind / sind Ihre Kinder bei Mietantritt?",
      "formChildInputPlaceholder": "ist wie alt?",
      "formPromotionCode": "Promotion Code",
      "formPromotionCodeNotFound": "Dieser Promotioncode existiert nicht.",
      "noResults": "Keine Ergebnisse gefunden"
    },
    "trustpilot": {
      "dateformat": "d/M/yyyy",
      "score": "Vertrauenswürdigkeit",
      "reviews": "Bewertungen",
      "reviewsOn": "Bewertungen zu"
    },
    "navigation": {
      "skihire": "Skiverleih",
      "skischool": "Skischulen",
      "accommodation": "Unterkünfte",
      "aboutUs": "Über uns",
      "helpCenter": "Hilfe & Support",
      "subnavBooking": "Buchung",
      "subnavAdditionalOffers": "Zusatzangebote",
      "subnavGroupBooking": "Gruppenbuchungen",
      "subnavTermsAndConditions": "AGBs",
      "subnavBecomePartner": "Werden Sie Partner",
      "subnavPrivacyPolicy": "Datenschutzbestimmung",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Mein Alpy.com",
      "subnavLogin": "Login",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Buchungen & Stornierungen",
      "subnavPersonalSettings": "Persönliche Einstellugen",
      "career": "Karriere",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Bitte wählen Sie ein Land"
    },
    "topCountries": "Führende Länder",
    "PF": {
      "showTownReserveEarlyEnoughInfo": "Bitte beachten Sie, dass es während der Skisaison zu einem Materialengpass kommen kann. Wir empfehlen Ihnen rechtzeitig zu buchen.",
      "heroBenefits": {
        "headline": "Jetzt die besten Verleih-Preise sichern",
        "subheadline": "Bis zu <span>-{{discount}}%</span> Billiger*",
        "benefitsHeader": "Vorteile",
        "benefitFirst": "Jetzt bis zu -{{discount}}% Einsparungen im Vergleich zu den Preisen in den Geschäften",
        "benefitFourth": "Online buchen - im Shop abholen",
        "benefitSecond": "Keine sonstigen Gebühren",
        "benefitThird": "Flexible Stornierung & Umbuchung"
      },
      "start": {
        "selectBookingParametersFact3": "Über 600 Verleih-Shops online"
      }
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Über Alpy.com",
      "metaDescription": "Hier finden Sie alle Informationen zum Team von Alpy.com, Vertrauen Sie einem der größten Skiverleih und Skischulen Netzwerke Europas!"
    },
    "imprint": {
      "title": "Impressum {{ productName }}",
      "metaDescription": "Impressum von {{ productName }}"
    },
    "privacy": {
      "title": "Datenschutzbestimmungen von {{ productName }}",
      "metaDescription": "Datenschutzbestimmungen von {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Allgemeine Geschäftsbedingungen | {{ productName }}",
      "metaDescription": "Datenschutzbestimmungen von {{ productName }}"
    },
    "additionalOffers": {
      "title": "Zusatzangebote"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "buchung-stornieren",
    "SKIHIREENTRY": "skiverleih",
    "COUNTRIES": "laender",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "suche"
    },
    "SKISCHOOLENTRY": "skischule",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "impressum",
      "PRIVACYPOLICY": "datenschutzbestimmungen",
      "TERMSANDCONDITIONS": "agbs",
      "HELP": "hilfe",
      "ABOUTUS": "ueber-uns",
      "ADDITIONALOFFERS": "zusatzangebote",
      "HOWTO": "anleitung"
    }
  }
}